import { useTranslation } from 'react-i18next'
import { useDashboardStats } from '@/hooks/api'
import { statCardConfigs } from './StatCards.static'

export function useStatCards() {
  const { t } = useTranslation('dashboard')
  const { totalPatients, activePatients, totalStaff, totalDocuments, isLoading, isError } =
    useDashboardStats()

  const valueMap: Record<string, number> = {
    'stats.totalPatients': totalPatients,
    'stats.activePatients': activePatients,
    'stats.totalStaff': totalStaff,
    'stats.documentsThisMonth': totalDocuments,
  }

  const stats = statCardConfigs.map((config) => ({
    ...config,
    label: t(config.labelKey),
    value: valueMap[config.labelKey],
  }))

  return { stats, isLoading, isError }
}
